export enum ErrorActionType {
  SET_VALIDATE_PAYMENT_ERROR = 'SET_VALIDATE_PAYMENT_ERROR',
  SET_VALIDATE_PAYMENT_ERROR_MESSAGE = 'SET_VALIDATE_PAYMENT_ERROR_MESSAGE',
  SET_ERROR_INFO_TEXT = 'SET_ERROR_INFO_TEXT',
  SET_ERROR_TYPE = 'SET_ERROR_TYPE',
  SET_TRACKING_PAGE_NAME = 'SET_TRACKING_PAGE_NAME',
  SET_VALIDATION = 'SET_VALIDATION',
}
